module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-world-treasures-in-wichita-kansas-8bee6498681295f0ea44935974083529.png";